import { Link } from "react-router-dom";
import { openPreferences as openCookiePrefs } from "@/lib/consent";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-[#eef1f6]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-6 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <div className="w-7 h-7 rounded-lg bg-[#0b1e5a] flex items-center justify-center">
              <svg viewBox="0 0 64 64" className="w-full h-full">
                <text x="29" y="48" textAnchor="middle" fontFamily="Inter, system-ui, -apple-system, sans-serif" fontWeight="700" fontSize="48" fill="#ffffff" letterSpacing="-2">s</text>
                <circle cx="48" cy="44" r="6" fill="#ac62ea" />
              </svg>
            </div>
            <span className="font-display text-lg font-semibold">SideB</span>
          </div>
          <p className="mt-5 text-sm text-muted-foreground max-w-md leading-relaxed">
            An AI-first consultancy optimizing digital revenue performance. We partner with Payments, Agentic Commerce, Finance, Product, and RevOps leaders to cut vendor costs, sharpen acceptance economics, and modernize procurement — unlocking hidden revenue in your payments stack.
          </p>
        </div>
        <div>
          <div className="label-mono">Work with us</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/services" className="hover:text-[#ac62ea]">Services</Link></li>
            <li><Link to="/inquiry" className="hover:text-[#ac62ea]">Custom project</Link></li>
            <li><Link to="/dashboard" className="hover:text-[#ac62ea]">Client dashboard</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-mono">AI Products</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/parse" className="block group" data-testid="footer-parse-link">
                <span className="font-medium group-hover:text-[#ac62ea]">Parse</span>
                <span className="block text-xs text-muted-foreground mt-0.5 leading-snug">
                  Get your free AI optimization assessment today.
                </span>
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="label-mono">Talk to us</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link
                to="/contact"
                className="block hover:text-[#ac62ea]"
                data-testid="footer-sales-chat"
              >
                <span className="text-muted-foreground block text-xs">Sales inquiries</span>
                Talk to us &rarr;
              </Link>
            </li>
            <li>
              <a href="mailto:rev@sideb.io" className="hover:text-[#ac62ea]" data-testid="footer-support-email">
                <span className="text-muted-foreground block text-xs">Customer service</span>
                rev@sideb.io
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="label-mono">Company</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-[#ac62ea]">About</Link></li>
            <li><Link to="/insights" className="hover:text-[#ac62ea]" data-testid="footer-insights-link">Insights &amp; blog</Link></li>
            <li><Link to="/agent" className="hover:text-[#ac62ea]" data-testid="footer-agent-link">Refer a deal (Agent)</Link></li>
            <li><Link to="/security" className="hover:text-[#ac62ea]" data-testid="footer-security-link">Security &amp; trust</Link></li>
            <li><Link to="/terms" className="hover:text-[#ac62ea]" data-testid="footer-terms-link">Online Services Agreement</Link></li>
            <li><Link to="/privacy" className="hover:text-[#ac62ea]" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li>
              <button
                type="button"
                onClick={openCookiePrefs}
                className="text-left hover:text-[#ac62ea]"
                data-testid="footer-cookies-link"
              >
                Cookie preferences
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row justify-between gap-2 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Sideb Studio LLC. All rights reserved.</span>
          <span>AI-First Consulting Studio · Orange County, CA</span>
        </div>
      </div>
    </footer>
  );
}
